import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '~/lib/query-client';
import { AuthProvider } from '~/features/auth/auth-context';
import { ToastProvider } from '~/ui/overlays';
import { router } from './router';
import './app.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('ไม่พบ #root element');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
